import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.25 2.969h-1.093a.498.498 0 0 0-.392.19L6.323 11.32l-3.09-3.914a.5.5 0 0 0-.391-.19H1.75a.125.125 0 0 0-.099.201l4.28 5.422c.2.253.584.253.786 0l7.631-9.67a.124.124 0 0 0-.099-.2Z" }));
const ForwardRef = forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
